import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { NovedadesProyectoDocumentosDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class NovedadesProyectoDocumentosService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getNovedadesProyectoDocumentosService(): Observable<BodyListResponse<NovedadesProyectoDocumentosDTO>> {
    return this.http.get<BodyListResponse<NovedadesProyectoDocumentosDTO>>(API_URL + '/api/v1/novedadesProyectoDocumentos/todos');
  }

  guardarNovedadesProyectoDocumentosService(novedadesProyectoDocumentosDTO: NovedadesProyectoDocumentosDTO): Observable<BodyResponse<NovedadesProyectoDocumentosDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/novedadesProyectoDocumentos', novedadesProyectoDocumentosDTO);
  }

  getNovedadesProyectoDocumentosPorCodigoService(codigo: string): Observable<BodyResponse<NovedadesProyectoDocumentosDTO>> {
    return this.http.get<BodyResponse<NovedadesProyectoDocumentosDTO>>(API_URL + '/api/v1/novedadesProyectoDocumentos/' + codigo);
  }
  /***************************buscar las observaciones por*******/
  getNovedadesProyectoDocumentosPorCodigoDocumentoService(codigoDocumento: string): Observable<BodyListResponse<NovedadesProyectoDocumentosDTO>> {
    return this.http.get<BodyListResponse<NovedadesProyectoDocumentosDTO>>(API_URL + '/api/v1/novedadesProyectoDocumentos/documentos/' + codigoDocumento);
  }
}
